import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  generalQ: [],
  sellerQ: [],
  buyerQ: [],
  privacyContent: [],
  termsContent: [],
  homeContent: [],
  insertContent: [],
  newsletterContent: [],
  insertBidContent: [],
  sellingData: [],
  buyingData: [],
  finalizingData: [],
  contactData: [],
  sellItemData: [],
  aboutusContent: [],
  photoguideContent: [],
  headerContent: [],
  cookiepolicydata: [],
  termdata: [],
  aboutdata: [],
  howitworkdata: [],
  privacypolicydata: [],
  dpadata: [],
  faqdata: [],
  faqsellerdata: [],
  faqbuyerdata: [],
};

const cmsSlice = createSlice({
  name: 'cms',
  initialState,
  reducers: {
    setGeneralQuestions: (state, action) => {
      state.generalQ = action.payload;
    },
    setSellerQuestions: (state, action) => {
      state.sellerQ = action.payload;
    },
    setBuyerQuestions: (state, action) => {
      state.buyerQ = action.payload;
    },
    setPrivacyPolicy: (state, action) => {
      state.privacyContent = action.payload;
    },
    setTermsConditions: (state, action) => {
      state.termsContent = action.payload;
    },
    setHomeContent: (state, action) => {
      state.homeContent = action.payload;
    },
    setInsertBidContent: (state, action) => {
      state.insertContent = action.payload;
    },
    setNewsletterContent: (state, action) => {
      state.newsletterContent = action.payload;
    },
    setWhatIsInsertBid: (state, action) => {
      state.insertBidContent = action.payload;
    },
    setSellingData: (state, action) => {
      state.sellingData = action.payload;
    },
    setBuyingData: (state, action) => {
      state.buyingData = action.payload;
    },
    setFinalizingData: (state, action) => {
      state.finalizingData = action.payload;
    },
    setContactData: (state, action) => {
      state.contactData = action.payload;
    },
    setSellItemData: (state, action) => {
      state.sellItemData = action.payload;
    },
    setAboutContent: (state, action) => {
      state.aboutusContent = action.payload;
    },
    setPhotoGuideContent: (state, action) => {
      state.photoguideContent = action.payload;
    },
    setHeaderContent: (state, action) => {
      state.headerContent = action.payload;
    },
    setCookiePolicyData: (state, action) => {
      state.cookiepolicydata = action.payload;
    },
    setHandleTermData: (state, action) => {
      state.termdata = action.payload;
    },
    setAboutData: (state, action) => {
      state.aboutdata = action.payload;
    },
    setHowItWorkData: (state, action) => {
      state.howitworkdata = action.payload;
    },
    setPrivacyPolicyData: (state, action) => {
      state.privacypolicydata = action.payload;
    },
    setDpaData: (state, action) => {
      state.dpadata = action.payload;
    },
    setFaqData: (state, action) => {
      state.faqdata = action.payload;
    },
    setFaqSellerData: (state, action) => {
      state.faqsellerdata = action.payload;
    },
    setFaqBuyerData: (state, action) => {
      state.faqbuyerdata = action.payload;
    },
  },
});

export const {
  setGeneralQuestions,
  setSellerQuestions,
  setBuyerQuestions,
  setPrivacyPolicy,
  setTermsConditions,
  setHomeContent,
  setInsertBidContent,
  setNewsletterContent,
  setWhatIsInsertBid,
  setSellingData,
  setBuyingData,
  setFinalizingData,
  setContactData,
  setSellItemData,
  setAboutContent,
  setPhotoGuideContent,
  setHeaderContent,
  setCookiePolicyData,
  setHandleTermData,
  setAboutData,
  setHowItWorkData,
  setPrivacyPolicyData,
  setDpaData,
  setFaqData,
  setFaqSellerData,
  setFaqBuyerData,
} = cmsSlice.actions;
export default cmsSlice.reducer;

